<template>
  <div id="admin">
    <h2>Liste des dernières recherches</h2>
    <h4>Filtres</h4>
    <div class="actions actions-location m-b-1">
      <button class="btn btn-small" @click="location = 'all'" :class="{'active': location == 'all'}">Locations / Ventes</button>
      <button class="btn btn-small" @click="location = 'location'" :class="{'active': location == 'location'}">Locations uniquement</button>
      <button class="btn btn-small" @click="location = 'vente'" :class="{'active': location == 'vente'}">Ventes uniquement</button>
    </div>
    <div class="actions actions-bureaux">
      <button class="btn btn-small" @click="bureaux = 'all'" :class="{'active': bureaux == 'all'}">Bureaux / Locaux</button>
      <button class="btn btn-small" @click="bureaux = 'bureaux'" :class="{'active': bureaux == 'bureaux'}">Bureaux uniquement</button>
      <button class="btn btn-small" @click="bureaux = 'local'" :class="{'active': bureaux == 'local'}">Locaux commerciaux uniquement</button>
    </div>
    <h4>{{ current_researches.length }} résultat<span v-if="current_researches.length > 1">s</span> sur {{ researches.length }}</h4>
    <div class="cards" v-if="researches">
      <div class="card" v-for="(r, index) in current_researches">
        <div class="onglet">
          <h6 class="bold">Recherche n°{{ r.id }} | le <span class="date">{{ new Date(r.created_at).toLocaleDateString('fr-FR') }} à {{ new Date(r.created_at).toLocaleTimeString('fr-FR') }}</span></h6>
          <div>
            <label>Type de locaux :</label> <span>{{ r.is_location ? 'Location' : 'Vente' }} | {{ r.is_bureaux ? 'Bureaux' : 'Local commercial' }}</span>
          </div>
          <div>
            <label>Budget :</label> <span>{{ r.budget_mini }} - {{ r.budget_maxi }}€</span>
          </div>
          <div>
            <label>Surface :</label> <span>{{ r.surface_mini }} - {{ r.surface_maxi }} m<sup>2</sup></span>
          </div>
          <br>
          <div>
            <label>Densité de population :</label> <span>{{ r.density == 'oui' ? 'Élevée' : (r.density == 'non' ? 'Basse' : 'Pas important') }}</span>
          </div>
          <div>
            <label>Revenu de la population :</label> <span>{{ r.revenu == 'oui' ? 'Élevé' : 'Pas important' }}</span>
          </div>
          <div>
            <label>Présence de la fibre :</label> <span>{{ r.fibre == 'oui' ? 'Important' : 'Pas important' }}</span>
          </div>
          <div>
            <label>Accès aux transports en commun :</label> <span>{{ r.transports == 'oui' ? 'Important' : 'Pas important' }}</span>
          </div>
          <div>
            <label>Présence d'entreprises concurrentes :</label> <span>{{ r.concurrentes == 'oui' ? 'Oui' : (r.concurrentes == 'non' ? 'Non' : 'Pas important') }}</span>
          </div>
          <div>
            <label>Présence d'entreprises complémentaires :</label> <span>{{ r.complementaires == 'oui' ? 'Oui' : 'Pas important' }}</span>
          </div>
        </div>
        <div class="onglet">
          <h6 class="bold">Détails de l'utilisateur</h6>
          <div>
            <label>SIRET :</label> <span>{{ r.siret }}</span>
          </div>
          <div>
            <label>Code NAF :</label> <span>{{ labelNaf(r.code_naf) }}</span>
          </div>
          <div>
            <label>Email :</label> <span>{{ r.user.email }}</span>
          </div>
          <div>
            <label>Prénom :</label> <span class="capitalize">{{ r.user.firstname }}</span>
          </div>
          <div>
            <label>Nom :</label> <span class="capitalize">{{ r.user.lastname }}</span>
          </div>
          <div>
            <label>Genre :</label> <span>{{ r.user.sexe == 'man' ? 'Homme' : (r.user.sexe == 'woman' ? 'Femme' : 'Non communiqué' )}}</span>
          </div>
        </div>
      </div>
    </div>
    <!-- <table>
      <thead>
        <tr>
          <th colspan="3">Recherche</th>
          <th colspan="4">Utilisateur associé</th>
        </tr>
        <tr>
          <th>Date</th>
          <th>Type de locaux</th>
          <th>Code NAF</th>
          <th>Email</th>
          <th>Prénom</th>
          <th>Nom</th>
          <th>Genre</th>
        </tr>
      </thead>
      <tbody v-if="researches">
        <tr v-for="r in researches">
          <td>{{ new Date(r.created_at).toLocaleDateString('fr-FR') }} à {{ new Date(r.created_at).toLocaleTimeString('fr-FR') }}</td>
          <td>{{ r.is_location ? 'Location' : 'Vente' }}</td>
          <td>{{ r.code_naf }}</td>
          <td><a :href="'mailto:' + r.user.email">{{ r.user.email }}</a></td>
          <td class="capitalize">{{ r.user.firstname ? r.user.firstname : 'Non communiqué' }}</td>
          <td class="capitalize">{{ r.user.lastname ? r.user.lastname : 'Non communiqué' }}</td>
          <td>{{ r.user.sexe == 'man' ? 'Homme' : (r.user.sexe == 'woman' ? 'Femme' : 'Non communiqué' )}}</td>
        </tr>
      </tbody>
    </table> -->
  </div>  
</template>

<script type="text/javascript">
import { mapGetters, mapMutations, mapActions } from 'vuex'

export default {
  name: 'Admin',
  computed: {
    ...mapGetters(['getUrl'])
  },
  data() {
    return {
      researches: [],
      current_researches: [],
      location: 'all',
      bureaux: 'all',
      nafs: [
        {label: "10.13B - Charcuterie", code: '10.13B'},
        {label: "10.71C - Boulangerie et boulangerie-pâtisserie", code: '10.71C'}, 
        {label: "10.71D - Pâtisserie", code: '10.71D'}, 
        {label: "41.10A - Promotion immobilière de logements", code: '41.10A'},
        {label: "41.10B - Promotion immobilière de bureaux", code: '41.10B'},
        {label: "43.32C - Agencement de lieux de vente", code: '43.32C'},
        {label: "45.11Z - Commerce de voitures et de véhicules automobiles légers", code: '45.11Z'},
        {label: "45.20A - Entretien et réparation de véhicules automobiles légers", code: '45.20A'},
        {label: "45.20B - Entretien et réparation d'autres véhicules automobiles", code: '45.20B'},
        {label: "45.32Z - Commerce de détail d'équipements automobiles", code: '45.32Z'}, 
        {label: "45.40Z - Commerce et réparation de motocycles", code: '45.40Z'},
        {label: "47.11A - Commerce de détail de produits surgelés", code: '47.11A'},
        {label: "47.11B - Commerce de d'alimentation générale", code: '47.11B'},
        {label: "47.11C - Supérettes", code: '47.11C'},
        {label: "47.11D - Supermarchés", code: '47.11D'},
        {label: "47.11E - Magasins multi-services", code: '47.11E'},
        {label: "47.19A - Grands magasins", code: '47.19A'},
        {label: "47.19B - Autres commerces de détail en magasin non spécialisé", code: '47.19B'},
        {label: "47.21Z - Commerce de détail de fruits et légumes en magasin spécialisé", code: '47.21Z'},
        {label: "47.22Z - Commerce de détail de viandes et de produits à base de viande en magasin spécialisé", code: '47.22Z'},
        {label: "47.23Z - Commerce de détail de poissons, crustacés et mollusques en magasin spécialisé", code: '47.23Z'},
        {label: "47.24Z - Commerce de détail de pain, pâtisserie et confiserie en magasin spécialisé", code: '47.24Z'},
        {label: "47.25Z - Commerce de détail de boissons en magasin spécialisé", code: '47.25Z'},
        {label: "47.26Z - Commerce de détail de produits à base de tabac en magasin spécialisé", code: '47.26Z'},
        {label: "47.29Z - Autres commerces de détail alimentaires en magasin spécialisé", code: '47.29Z'},
        {label: "47.30Z - Commerce de détail de carburants en magasin spécialisé", code: '47.30Z'},
        {label: "47.41Z - Commerce de détail d'ordinateurs, d'unités périphériques et de logiciels en magasin spécialisé", code: '47.41Z'},
        {label: "47.42Z - Commerce de détail de matériels de télécommunication en magasin spécialisé", code: '47.42Z'},
        {label: "47.43Z - Commerce de détail de matériels audio et vidéo en magasin spécialisé", code: '47.43Z'},
        {label: "47.51Z - Commerce de détail de textiles en magasin spécialisé", code: '47.51Z'},
        {label: "47.52A - Commerce de détail de quincaillerie, peintures et verres en petites surfaces (moins de 400 m²)", code: '47.52A'},
        {label: "47.52B - Commerce de détail de quincaillerie, peintures et verres en grandes surfaces (400 m² et plus)", code: '47.52B'},
        {label: "47.53Z - Commerce de détail de tapis, moquettes et revêtements de murs et sols en magasin spécialisé", code: '47.53Z'},
        {label: "47.54Z - Commerce de détail d'appareils électroménagers en magasin spécialisé", code: '47.54Z'},
        {label: "47.59A - Commerce de détail de meubles", code: '47.59A'},
        {label: "47.59B - Commerce de détail d'autres équipements du foyer", code: '47.59B'},
        {label: "47.61Z - Commerce de détail de livres en magasin spécialisé", code: '47.61Z'},
        {label: "47.62Z - Commerce de détail de journaux et papeterie en magasin spécialisé", code: '47.62Z'},
        {label: "47.63Z - Commerce de détail d'enregistrements musicaux et vidéo en magasin spécialisé", code: '47.63Z'},
        {label: "47.64Z - Commerce de détail d'articles de sport en magasin spécialisé", code: '47.64Z'},
        {label: "47.65Z - Commerce de détail de jeux et jouets en magasin spécialisé", code: '47.65Z'},
        {label: "47.71Z - Commerce de détail d'habillement en magasin spécialisé", code: '47.71Z'},
        {label: "47.72A - Commerce de détail de la chaussure", code: '47.72A'},
        {label: "47.72B - Commerce de détail de la maroquinerie et d'articles de voyage", code: '47.72B'},
        {label: "47.73Z - Commerce de détail de produits pharmaceutiques en magasin spécialisé", code: '47.73Z'},
        {label: "47.74Z - Commerce de détail d'articles médicaux et orthopédiques en magasin spécialisé", code: '47.74Z'},
        {label: "47.75Z - Commerce de détail de parfumerie et de produits de beauté en magasin spécialisé", code: '47.75Z'},
        {label: "47.76Z - Commerce de détail de fleurs, plantes, graines, engrais, animaux en spécialisé", code: '47.76Z'},
        {label: "47.77Z - Commerce de détail d'articles d'horlogerie et de bijouterie en magasin spécialisé", code: '47.77Z'},
        {label: "47.78A - Commerces de détail d'optique", code: '47.78A'},
        {label: "49.42Z - Servies de déménagement", code: '49.42Z'},
        {label: "52.29A - Messagerie, fret express", code: '52.29A'},
        {label: "55.10Z - Hôtels et hébergement similaire", code: '55.10Z'},
        {label: "56.10A - Restauration traditionnelle", code: '56.10A'}, 
        {label: "56.10B - Cafétérias et autres libres-services", code: '56.10B'},
        {label: "56.10C - Restauration de type rapide", code: '56.10C'},
        {label: "56.30Z - Débits de boissons", code: '56.30Z'},
        {label: "62.02A - Conseils en systèmes et logiciels informatiques", code: '62.02A'},
        {label: "68.31Z - Agences immobilières", code: '68.31Z'},
        {label: "69.10Z - Activités juridiques", code: '69.10Z'},
        {label: "69.20Z - Activités comptables", code: '69.20Z'},
        {label: "70.22Z - Conseils pour les affaires et la gestion", code: '70.22Z'},
        {label: "71.11Z - Activités d'architectures", code: '71.11Z'},
        {label: "73.11Z - Agences de pub", code: '73.11Z'},
        {label: "82.11Z - Services administratifs combinés de bureau", code: '82.11Z'},
        {label: "86.21Z - Activité des médecins généralistes", code: '86.21Z'},
        {label: "93.19Z - Autres activités liées au sport", code: '93.19Z'},
        {label: "96.01B - Blanchisserie-teinturerie de détail", code: '96.01B'},
        {label: "96.02A - Coiffure", code: '96.02A'},
        {label: "96.02B. - Soins de beauté", code: '96.02B'}
      ]
    }
  },
  mounted() {
    this.$http.get(this.getUrl + '/admin/researches')
      .then(response => {
        if (response.ok) {
          console.log(response)
          this.researches = response.data
        }
      })
  },
  methods: {
    labelNaf(code) {
      let naf = null
      this.nafs.map(n => {
        if (n.code == code) naf = n.label
      })
      return naf
    },
    editResearch() {
      this.current_researches = []
      this.researches.map(r => {
        if (r.is_location) {
          if (this.location != 'vente') {
            if (r.is_bureaux) {
              if (this.bureaux != 'local') this.current_researches.push(r)
            } else {
              if (this.bureaux != 'bureaux') this.current_researches.push(r)
            }
          }
        } else {
          if (this.location != 'location') {
            if (r.is_bureaux) {
              if (this.bureaux != 'local') this.current_researches.push(r)
            } else {
              if (this.bureaux != 'bureaux') this.current_researches.push(r)
            }
          }
        }
      })
    }
  },
  watch: {
    researches(value) {
      if (value) this.current_researches = this.researches
    },
    location() {
      this.editResearch()
    },
    bureaux() {
      this.editResearch()
    }
  }
}
</script>

<style lang="scss">
  #admin {
    width: 100%;
    height: 100%;
    background: $white;
    padding: 4rem;
  }
  h2 {
    text-align: center;
  }
  h4 {
    padding-left: 3rem;
    margin-bottom: 1rem;
  }
  .actions {
    padding-left: 2rem;
  }
  .actions .btn {
    width: 25rem;
  }
  .actions-location .btn {
    background: $white;
    color: $primary;
    border: 1px solid $primary;
    margin-right: 1rem;
  }
  .actions-location .btn.active {
    background: $primary;
    color: $white;
  }
  .actions-bureaux .btn {
    background: $white;
    color: $secondary;
    border: 1px solid $secondary;
    margin-right: 1rem;
  }
  .actions-bureaux .btn.active {
    background: $secondary;
    color: $white;
  }
  .date {
    text-decoration: underline;
  }
  .cards {
    width: 100%;
    display: flex;
    flex-wrap: wrap;
  }
  .card {
    width: 100%;
    padding: 2rem;
    margin: 1rem;
    color: $text;
    display: flex;
    flex-direction: row;
  }
  .card .onglet {
    width: 50%;
  }
  .card .onglet div {
    padding: .1rem 0;
  }
  .card h6 {
    color: $primary;
    text-transform: uppercase;
  }
  .card label {
    font-family: 'Montserrat-Bold';
    //text-decoration: underline;
    color: $secondary;
  }
  .card span {
    color: $primary;
    font-family: 'Montserrat-Bold';
  }
  table {
    color: $primary;
    border-collapse: collapse;
    border: 1px solid $primary;
    width: 100%;
  }
  th, tr, td {
    border: 2px solid $primary;
  }
  thead tr {
    background: $primary;
    color: $white;
  }
  thead tr:nth-child(2n) {
    background: $white;
    color: $primary;
  }
  thead tr:nth-child(2n + 1) th {
    border: 1px solid $white;
  }
  thead tr th {
    padding: .5rem 0rem;
    text-transform: uppercase;
  }
  tbody tr:nth-child(2n + 1) {
    background: $light;
  }
  tbody td {
    font-size: 1.4rem;
    line-height: 2.2rem;
    padding-left: 1rem;
  }
  .capitalize {
    text-transform: capitalize;
  }
</style>
